import IntersectionObserver from './IntersectionObserver';

export default IntersectionObserver;
